import { render, staticRenderFns } from "./PreviewSlot.vue?vue&type=template&id=b21e1a56&scoped=true"
import script from "./PreviewSlot.vue?vue&type=script&lang=js"
export * from "./PreviewSlot.vue?vue&type=script&lang=js"
import style0 from "./PreviewSlot.vue?vue&type=style&index=0&id=b21e1a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21e1a56",
  null
  
)

export default component.exports